import { createSlice } from '@reduxjs/toolkit'

import { fetchFieldValues } from '../actions/fetchFieldValues'

import { FilterFieldValuesState } from './interfaces'

export const initialState: FilterFieldValuesState = {
  query: '',
  items: [],
  fetching: false,
  error: null,
}

export const filterFieldValuesSlice = createSlice({
  name: 'values',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFieldValues.pending, (state, action) => {
        state.query = action.meta.arg?.query ?? ''
        state.fetching = true
        state.error = null
      })
      .addCase(fetchFieldValues.fulfilled, (state, action) => {
        const { query } = action.meta.arg
        if (query !== state.query) return
        state.items = action.payload?.data?.values || []
        state.fetching = false
        state.error = null
      })
      .addCase(fetchFieldValues.rejected, (state, action) => {
        const query = action.meta.arg?.query ?? ''
        if (query !== state.query) return
        state.items = []
        state.fetching = false
        state.error = action.error?.message || null
      })
  },
})
